export default function getWishlistState(state) {
    return state.wishlistState || {};
}
